import Address from 'services/Address'

import {
  Container,
  Image,
  Column,
  SubTitle,
  InfoText
} from './styles'

export default function Business ({
  data: business,
  clickable = true,
  selected = false,
  onSelect: handleSelect = () => null
}) {
  return (
    <Container
      onClick={() => handleSelect (business)}
      clickable={clickable}
      selected={selected}
    >
      <Image src={business.logo}/>
      <Column>
        <SubTitle>
          {business.name}
        </SubTitle>
        <InfoText>
          {Address.formatAddress (business.addresses[0])}
        </InfoText>
      </Column>
    </Container>
  )
}
